import { AmChartsService } from '@amcharts/amcharts3-angular';
import { SurvivalHorizonService } from './../../survival-horizon/survival-horizon.service';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { MetricSelection } from './../metric-selection';
import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { BalanceMetric } from './balance-metric';
import { TrendMetric } from './../trend-metric/trend-metric';

@Component({
    selector: 'app-balance-metric',
    templateUrl: './balance-metric.component.html',
    styleUrls: ['./balance-metric.component.scss', './../trend-metric/trend-metric.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BalanceMetricComponent implements OnInit, OnDestroy {
    @Input()
    balanceMetric: BalanceMetric;

    constructor(private amCharts: AmChartsService,
        private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private changeDetectorRef: ChangeDetectorRef) {

    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.changeDetectorRef.detach();
    }

    refreshMetric() {
        this.changeDetectorRef.markForCheck();
    }

    lightMetricColor(balanceMetric: BalanceMetric) {
        if (balanceMetric.initialized) {
            // return TrendMetric.C_300[3];
            return '#f8f8f8';
        }
    }
}
